module.exports = __webpack_public_path__ + "static/media/mc_pulse_black.3291324b.svg";